import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.setAttribute('style', 'height: 100%; min-height: 300px; width: 100%;')

    const lat = parseFloat(this.element.dataset.lat)
    const lon = parseFloat(this.element.dataset.lon)
    const pinPath = this.element.dataset.pinPath

    this.map = L.map(this.element).setView([lon, lat], 10)

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(this.map)

    const pinIcon = L.icon({
      iconUrl: pinPath,
      iconAnchor: [24, 64]
    })

    L.marker([lon, lat], { icon: pinIcon }).addTo(this.map)

    const routeJson = this.element.dataset.route
    if (routeJson) {
      try {
        const route = JSON.parse(routeJson)
        if (route?.geometry) {
          const layer = L.geoJSON(route.geometry, { style: { color: '#ff4e00', weight: 4, opacity: 0.9 } }).addTo(this.map)
          this.map.fitBounds(layer.getBounds(), { padding: [20, 20] })
        }
      } catch (e) {
        console.error('Invalid route data', e)
      }
    }
  }
}
